import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';

import { completeStep } from '@/actions/expertComplianceTraining';
import Wizard from '@/components/Wizard';

const ComplianceWizard = (props: any) => {
  const navigate = useNavigate();
  const onNext = () => {
    const { completeStep, nextUrl, user, path } = props;

    completeStep(path, user.id);
    navigate(nextUrl);
  };

  const { children, ...other } = props;
  const page = React.cloneElement(children, { onNext });

  return <Wizard {...other}>{page}</Wizard>;
};

export default connect(null, {
  completeStep,
})(ComplianceWizard);
